import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { BaseResponse } from 'types/utils'

import { TicketList } from '../types'
import { ticketsQueryKey } from './useTickets'

/** Admin tickets table — reads pagination + filters from the URL like the
 * other admin table queries. */
export function useTicketsTable() {
  const [searchParams] = useSearchParams()
  const limit = searchParams.get('limit')
  const offset = searchParams.get('offset')
  const status = searchParams.get('status')
  const category = searchParams.get('category')
  const priority = searchParams.get('priority')

  async function getTickets() {
    const res = await apiClient.get<BaseResponse<TicketList>>(
      `${SNA_PREFIX}tickets/`,
      { params: { limit, offset, status, category, priority } }
    )
    return res.data
  }

  return useQuery({
    queryFn: getTickets,
    queryKey: [...ticketsQueryKey, limit, offset, status, category, priority]
  })
}
